// extracted by mini-css-extract-plugin
export default {"container":"I4-z","heading":"J4-z","links":"K4-z","copy":"L4-z","subCopy":"M4-z","linksLeft":"N4-z","linksCenter":"O4-z","linksRight":"P4-z","link":"Q4-z","onlyLink":"R4-z"};